import type { Components, Theme } from '@mui/material/styles';

import { SHAPE } from './scales';

/** The kit lists: list rows and list options, table rows and table cells. */
export const LISTS: Components<Theme> = {
  MuiListItemButton: {
    styleOverrides: {
      root: ({ theme }) => ({
        ...theme.typography.body1,
        borderRadius: SHAPE.small,
        color: theme.vars.palette.grey[700],
        '&:hover': { backgroundColor: theme.vars.palette.action.hover },
        '&.Mui-selected, &.Mui-selected:hover': { backgroundColor: theme.vars.palette.tint.brand.fill },
        '&[role="option"]': {
          borderRadius: 0,
          '& svg': { color: theme.vars.palette.text.brand },
          '&.Mui-selected': { backgroundColor: 'transparent' },
          '&:hover, &.Mui-selected:hover': { backgroundColor: theme.vars.palette.action.hover },
        },
      }),
    },
  },
  MuiTableRow: {
    styleOverrides: {
      root: ({ theme }) => ({
        backgroundColor: theme.vars.palette.background.paper,
        '&.MuiTableRow-hover': { cursor: 'pointer' },
        '&.MuiTableRow-hover:hover': { backgroundColor: theme.vars.palette.action.hover },
        '&.Mui-selected, &.Mui-selected:hover': { backgroundColor: theme.vars.palette.tint.brand.fill },
      }),
    },
  },
  KitTableRow: {
    variants: [{ props: { subtle: true }, style: ({ theme }) => ({ backgroundColor: theme.vars.palette.grey[100] }) }],
  },
  MuiTableCell: {
    styleOverrides: {
      root: ({ theme }) => ({
        padding: '8px 12px',
        whiteSpace: 'nowrap',
        borderBottom: `1px solid ${theme.vars.palette.divider}`,
      }),
      head: ({ theme }) => ({
        ...theme.typography.label,
        textTransform: 'uppercase',
        letterSpacing: '0.05em',
        color: theme.vars.palette.text.secondary,
      }),
      body: ({ theme }) => ({ ...theme.typography.body1, color: theme.vars.palette.text.primary }),
    },
  },
  KitTableCell: {
    variants: [
      { props: { sticky: true }, style: { position: 'sticky', left: 0, zIndex: 1, backgroundColor: 'inherit' } },
    ],
  },
};
